import { render, staticRenderFns } from "./kyc-withdraw-address.vue?vue&type=template&id=05f48ba1&"
import script from "./kyc-withdraw-address.vue?vue&type=script&lang=js&"
export * from "./kyc-withdraw-address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports